<template>
  <div class="row">
    <div class="col-12">
      {{ $t("search.contractcode") }}
      <m-input
        v-model="search.CONTRACTCODE"
        class="search-form-field"
        nolabel
      ></m-input>
    </div>

    <div class="col-12">
      {{ $t("search.firmname") }}
      <m-input
        v-model="search.FIRMNAME"
        class="search-form-field"
        nolabel
      ></m-input>
    </div>

    <div class="col-12">
      {{ $t("search.fullname") }}
      <m-input
        v-model="search.FULLNAME"
        class="search-form-field"
        nolabel
      ></m-input>
    </div>

    <!--<div class="col-6">
      {{ $t("search.startdate") }}

      <m-input
        class="search-form-field"
        v-model="search.TRANSDATE[0]"
        nolabel
        type="date"
      ></m-input>
    </div>
    <div class="col-6">
      {{ $t("search.enddate") }}

      <m-input
        class="search-form-field"
        type="date"
        v-model="search.TRANSDATE[1]"
        nolabel
      ></m-input>
    </div>-->
  </div>
</template>

<script>
import api from "../../api";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["getPerms"]),
  },
  data() {
    return {
      search: {
        CONTRACTOCDE: null,
        FULLNAME: null,
        FIRLNAME: null,
      },
      options: {
        reseller: [],
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        CONTRACTOCDE: null,
        FULLNAME: null,
        FIRLNAME: null,
      };
    },
  },
};
</script>

<style></style>
